import { Flex, Tag, Text, TextProps, useClipboard, useToast } from '@chakra-ui/react';
import { useEffect, useMemo, useState } from 'react';
import { HiClipboardCopy } from 'react-icons/hi';

type Props = TextProps & {
  value: string;
};

export const CopyableText = ({ value, ...rest }: Props) => {
  const { onCopy, hasCopied } = useClipboard(value);
  const toast = useToast();
  const [isHovering, setIsHovering] = useState(false);

  useEffect(() => {
    if (hasCopied) {
      toast({
        title: `Copied ${value} to clipboard`,
        status: 'success',
        duration: 2000,
        isClosable: true,
      });
    }
  }, [hasCopied, toast, value]);

  const filter = useMemo(() => (isHovering ? 'blur(4px)' : 'none'), [isHovering]);

  return (
    <Flex position="relative" alignItems="center" minW={0} flex={1}>
      <Tag
        position="absolute"
        left={0}
        right={0}
        justifyContent="center"
        variant="ghost"
        visibility={isHovering ? 'visible' : 'hidden'}
      >
        <HiClipboardCopy />
        {hasCopied ? 'Copied' : 'Copy'}
      </Tag>
      <Text
        cursor="pointer"
        filter={filter}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
        onClick={onCopy}
        whiteSpace="pre-wrap"
        wordBreak="break-word"
        overflowWrap="anywhere"
        sx={{ display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}
        {...rest}
      >
        {value}
      </Text>
    </Flex>
  );
};
